import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=a03572b0"
import script from "./Train.vue?vue&type=script&lang=js"
export * from "./Train.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports